import React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
const SVG = ({
  className = '',
  size = '24'
}) => ___EmotionJSX("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: size,
  height: size,
  className: className,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, ___EmotionJSX("circle", {
  cx: "18",
  cy: "5",
  r: "3"
}), ___EmotionJSX("circle", {
  cx: "6",
  cy: "12",
  r: "3"
}), ___EmotionJSX("circle", {
  cx: "18",
  cy: "19",
  r: "3"
}), ___EmotionJSX("line", {
  x1: "8.59",
  y1: "13.51",
  x2: "15.42",
  y2: "17.49"
}), ___EmotionJSX("line", {
  x1: "15.41",
  y1: "6.51",
  x2: "8.59",
  y2: "10.49"
}));
export default SVG;